import React from 'react';
import { connect } from 'react-redux';
import { LoadingIcon } from '_components'
import styles from './Schedule.module.css'
import { TherapistDashboardScheduleRow } from './ScheduleRow';

class TherapistDashboardSchedule extends React.Component {

    renderUnAvailableBlocksContent(block) {
        const startformattedDate = this.Get12HourTime(block.blockStart);
        const endformattedDate = this.Get12HourTime(block.blockEnd);
        return (
            <div className={styles.appt_wrapper} id={block.blockStart + '_' + block.blockEnd} key={block.blockStart + '_' + block.blockEnd}>
                <span className={styles.col1_schedule}>Unavailable</span>
                <span className={styles.col2_schedule}>{startformattedDate} - {endformattedDate}</span>
                <span className={styles.col3_schedule}>{block.description}</span>
            </div>
        );
    }

    Get12HourTime(ms) {

        const totalMinutes = ms / (1000 * 60);

        const hours = Math.floor(totalMinutes / 60);
        const minutes = Math.floor(totalMinutes % 60);

        let displayHour = hours % 12;
        if (displayHour === 0) displayHour = 12; // Handle midnight and noon

        const period = hours < 12 ? 'AM' : 'PM'; // Determine AM or PM

        // Format minutes to always show two digits (e.g., 4:05 PM instead of 4:5 PM)
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

        // Return formatted 12-hour time with AM/PM
        return `${displayHour}:${formattedMinutes} ${period}`;
    }


    render() {

        const combinedItems = [
            ...Object.values(this.props.appts).map(appt => ({
                type: 'appointment',  // Differentiating appointment
                ...appt,
                time: this.Get12HourTime(appt.APTSTART),
                rawTime: appt.APTSTART,  // Store raw time (in ms) for sorting
            })),
            ...Object.values(this.props.unavailableBlocks).map(block => ({
                type: 'unavailable',  // Differentiating unavailable block
                ...block,
                time: this.Get12HourTime(block.blockStart),  // Convert blockStart to 12-hour format
                rawTime: block.blockStart,  // Store raw start time (in ms) for sorting
                blockEndTime: this.Get12HourTime(block.blockEnd),
                rawEndTime: block.blockEnd,  // Store raw block end time (in ms) for sorting
            }))
        ];

        combinedItems.sort((a, b) => a.rawTime - b.rawTime);  // Sorting in ascending order
        if (this.props.loading === true) {
            return (
                <div className={styles.loading_div}>
                    <br />
                    <label>Loading...</label>
                    <br /><br />
                    <LoadingIcon size='large' />
                </div>
            );
        } else {
            let index = 0;
            return (
                <div>
                    <div className={styles.header_wrapper}>
                        <span className={styles.col1}>Status</span>
                        <span className={styles.col2}>Care Center</span>
                        <span className={styles.col3}>Time</span>
                        <span className={styles.col4}>Patient</span>
                        <span className={styles.col5}>Location</span>
                        <span className={styles.col6} />
                        <span className={styles.col7} />
                    </div>
                    <div className={styles.schedule_table_large_component}>
                        {combinedItems.map((item, index) => {
                            if (item.type === 'appointment') {
                                return (
                                    <TherapistDashboardScheduleRow
                                        key={item.APTID}
                                        id={item.APTID}
                                        isOdd={index % 2 === 0 ? false : true}
                                    />
                                );
                            } else if (item.type === 'unavailable') {
                                return (
                                    <>
                                        {this.props.showUnavailable &&
                                            <div key={item.blockID}>
                                                {this.renderUnAvailableBlocksContent(item)}
                                            </div>
                                        }
                                    </>
                                );
                            }
                            return null;
                        })}
                    </div>

                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    let appts = Object.keys(state.entities.dashboard.schedule)
        .sort((a, b) => {
            if (state.entities.dashboard.schedule[a].APTSTART !== state.entities.dashboard.schedule[b].APTSTART) {
                return state.entities.dashboard.schedule[a].APTSTART - state.entities.dashboard.schedule[b].APTSTART;
            } else if (state.entities.dashboard.schedule[a].APTSTART === state.entities.dashboard.schedule[b].APTSTART &&
                state.entities.dashboard.schedule[a].APTDURATION !== state.entities.dashboard.schedule[b].APTDURATION) {
                return state.entities.dashboard.schedule[a].APTDURATION - state.entities.dashboard.schedule[b].APTDURATION;
            } else {
                return state.entities.dashboard.schedule[a].APTID - state.entities.dashboard.schedule[b].APTID;
            }
        })
        .filter((x) => {
            if (!state.ui.dashboard.showCxNs) {
                return state.entities.dashboard.schedule[x].ADTASID !== 4 && state.entities.dashboard.schedule[x].ADTASID !== 5
            } else {
                return true;
            }
        })
        .map(x => state.entities.dashboard.schedule[x]);


    return {
        loading: state.ui.dashboard.loadingSchedule,
        unavailableBlocks: state.entities.dashboard.unavailableBlocks,
        appts,
        showUnavailable: state.ui.dashboard.showUnavailable
    };
}

const connectedTherapistDashboardSchedule = connect(mapStateToProps)(TherapistDashboardSchedule);
export { connectedTherapistDashboardSchedule as TherapistDashboardSchedule };

